<div class="products-page-header">
  <div class="products-page-header__main">
    <h4 class="page-title">
      <i class="fas fa-box-open"></i>
      Produtos
      <span *ngIf="empresa?.catalogo?.compartilhado" class="badge badge-danger badge-sm ml-1" >catálogo compartilhado</span>
    </h4>

    <button class="btn btn-outline-primary" *ngIf="temModuloTabelaPrecos" (click)="abraTabelaPrecos()">
      <i class="fas fa-tags mr-1"></i>
      Tabelas preços
    </button>

    <a class="btn btn-outline-primary" href="/admin/produtos-v2" title="Experimentar o editor de produtos V2">
      <i class="fe-zap mr-1"></i>
      <span>Produtos V2</span>
    </a>
  </div>

  <div class="products-page-header__danger" *ngIf="usuario.admin">
    <button class="btn btn-warning" (click)="limparCache()"  [hidden]="confirmeRemover">
      <i class="fas fa-trash-alt mr-1"></i>
      Limpar cache
    </button>

    <button class="btn btn-danger" (click)="removerCatalogo()"  [hidden]="confirmeRemover">
      <i class="fas fa-trash-alt mr-1"></i>
      Limpar catalogo
    </button>
  </div>
</div>

<div class="alert alert-warning" *ngIf="empresa?.id && empresa?.catalogo?.compartilhado">
  <i class="fa fa-lock mr-1"></i>
  <strong>Catálogo controlado pela rede.</strong>
  Algumas informações dos produtos são administradas no Admin Rede. Para alterar dados bloqueados, solicite a edição ao responsável pelo catálogo da rede.
</div>


<h4 *ngIf="removendo" class="mt-1"><i class="k-icon k-i-loading"></i> removendo aguarde...</h4>


<div class="row" *ngIf="empresa?.catalogo">
 <div class="card-box" style="width: 100%;">
   <app-produtos2 #telaProdutos [empresa]="empresa" [catalogo]="empresa.catalogo"></app-produtos2>
 </div>
</div>
